module.exports = __webpack_public_path__ + "img/wild_table.ef4586d6.png";